"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var init_1 = require("./init");
function translate() {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    var messageKey = keys.join('.');
    var l10nMessages = init_1.getMessages();
    if (process.env.NODE_ENV === 'development' && !l10nMessages[messageKey]) {
        console.error("No message for: " + messageKey);
    }
    return l10nMessages[messageKey] || messageKey;
}
exports.translate = translate;
function translateWithParameters(messageKey) {
    var parameters = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        parameters[_i - 1] = arguments[_i];
    }
    var message = init_1.getMessages()[messageKey];
    if (message) {
        return parameters
            .map(function (parameter) { return String(parameter); })
            .reduce(function (acc, parameter, index) { return acc.replace("{" + index + "}", function () { return parameter; }); }, message);
    }
    else {
        if (process.env.NODE_ENV === 'development') {
            console.error("No message for: " + messageKey);
        }
        return messageKey + "." + parameters.join('.');
    }
}
exports.translateWithParameters = translateWithParameters;
function hasMessage() {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    var messageKey = keys.join('.');
    return init_1.getMessages()[messageKey] != null;
}
exports.hasMessage = hasMessage;
function getLocalizedMetricName(metric, short) {
    if (short === void 0) { short = false; }
    var bundleKey = "metric." + metric.key + "." + (short ? 'short_name' : 'name');
    if (hasMessage(bundleKey)) {
        return translate(bundleKey);
    }
    else if (short) {
        return getLocalizedMetricName(metric);
    }
    else {
        return metric.name || metric.key;
    }
}
exports.getLocalizedMetricName = getLocalizedMetricName;
function getLocalizedCategoryMetricName(metric) {
    var bundleKey = "metric." + metric.key + ".extra_short_name";
    return hasMessage(bundleKey) ? translate(bundleKey) : getLocalizedMetricName(metric, true);
}
exports.getLocalizedCategoryMetricName = getLocalizedCategoryMetricName;
function getLocalizedMetricDomain(domainName) {
    var bundleKey = "metric_domain." + domainName;
    return hasMessage(bundleKey) ? translate(bundleKey) : domainName;
}
exports.getLocalizedMetricDomain = getLocalizedMetricDomain;
function getCurrentLocale() {
    return init_1.getLocale();
}
exports.getCurrentLocale = getCurrentLocale;
function getShortMonthName(index) {
    var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    return translate(months[index]);
}
exports.getShortMonthName = getShortMonthName;
function getWeekDayName(index) {
    var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return weekdays[index] ? translate(weekdays[index]) : '';
}
exports.getWeekDayName = getWeekDayName;
function getShortWeekDayName(index) {
    var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return weekdays[index] ? translate(weekdays[index]) : '';
}
exports.getShortWeekDayName = getShortWeekDayName;
//# sourceMappingURL=l10n.js.map